import React from 'react'
import Divider from '@material-ui/core/Divider'
import SidebarItem from 'components/app-shell/sidebar-item'

export default function ResourceCenterNavItem(props) {
  return (
    <>
      <SidebarItem {...props} />
      {!props.collapsed && <Divider component="li" />}
    </>
  )
}
